import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const uuidValidatorGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const uuid   = route.paramMap.get('uuid') ?? '';

  if (UUID_REGEX.test(uuid)) {
    return true;
  }

  return router.createUrlTree(['/']);
};
